var path = 'app/logout/logout.html';
var html = "<div>\n  <h2>Please wait while we log you out</h2>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/logout/logout.html
// module id = ./app/logout/logout.html
// module chunks = 0